import { HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en-GB';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEnExtra from '@angular/common/locales/extra/en-GB';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { registerLocaleData } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  ApiModule,
  BASE_META_REDUCERS,
  BASE_REDUCERS,
  BaseModule,
  ENVIRONMENT,
  ENVIRONMENTER,
  AUTH_BOOTSTRAP_INITIALIZER_PROVIDER,
  UP_TO_DATE_INITIALIZER_PROVIDER,
  PORTAL_SETTINGS_PROVIDER,
  PORTAL_SETTINGS_INITIALIZER_PROVIDER,
  baseTranslateLoaderFactory,
  BaseSharedModule,
  BaseAssignmentsStoreModule,
  BaseRelatedCustomerLocationsStoreModule,
} from 'base';
import { LayoutModule } from './layout/layout.module';
import { environment } from '../environments/environment';
import { SharedModule } from './modules/shared/shared.module';
import { AppComponent } from './app.component';

registerLocaleData(localeDe, 'de', localeDeExtra);
registerLocaleData(localeEn, 'en', localeEnExtra);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BaseSharedModule,
    BaseModule,
    LayoutModule,
    AppRoutingModule,
    SharedModule,
    ApiModule.forRoot({ rootUrl: environment.global.apiUrl }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: baseTranslateLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'de',
    }),
    StoreModule.forRoot(BASE_REDUCERS, {
      metaReducers: BASE_META_REDUCERS,
      runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true },
    }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    BaseAssignmentsStoreModule,
    BaseRelatedCustomerLocationsStoreModule,
    !environment.global.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 25, //  Retains last 25 states
        })
      : [],
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: ENVIRONMENTER, useValue: environment },
    { provide: LOCALE_ID, useValue: 'de' },
    ...(environment.global.production || environment.global.staging || environment.global.demo
      ? [UP_TO_DATE_INITIALIZER_PROVIDER]
      : []),
    AUTH_BOOTSTRAP_INITIALIZER_PROVIDER,
    PORTAL_SETTINGS_INITIALIZER_PROVIDER,
    PORTAL_SETTINGS_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
